import { useState, useEffect } from "react";
import Style from "../../Plans/PlansDetailStyle";
import Spinner from "../../../shared/Spinner/Spinner";
import TwoButtonsModal from "../../../shared/Bootstrap/TwoButtonsModal";
import { AxiosRequestConfig } from "axios";
import api from "../../../services/api";
import PageTitle from "../../../components/PageTitle";
import { GetFileFromURL } from "../../../utils";
import { InputImage } from "../../../components/InputImage/InputImage";
import InfoModal from "../../../shared/Bootstrap/InfoModal";

export default function EnterpriseInfoPage(props) {

  const [page, setPage] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const [selectedImage, setSelectedImage] = useState({} as File);
  const [imageUrl, setImageUrl] = useState("");
  const [deleteImage, setDeleteImage] = useState(false);

  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const enterpriseId = props.match.params.enterpriseId;
  const infoId = props.match.params.infoId;
  const creatingNew = infoId <= 0;

  useEffect(() => {
    if (!creatingNew)
      LoadEnterpriseInfo();
  }, []);

  async function LoadEnterpriseInfo() {
    try {
      setLoading(true);
      const result = await api.get(`/enterprises/info/${infoId}`);
      if (!result.data.success) {
        setErrorMessage("Não foi possível carregar os dados da página " + (result.data.message ?? ""));
        return;
      }
      if (result.data.success) {
        setErrorMessage("");
        const enterpriseInfo = result.data.enterpriseInfo;
        setPage(enterpriseInfo.page);
        setTitle(enterpriseInfo.title);
        setDescription(enterpriseInfo.description);
        setImageUrl(enterpriseInfo.imageUrl);
        console.log(enterpriseInfo.imageUrl);
      }
    } catch (error: any) {
      console.error("Erro consultando dados da informação: ", error);
      setErrorMessage("Não foi possível carregar os dados da página: " + error.message);
    }
    finally {
      setLoading(false);
    }
  }

  async function OnSubmit() {
    try {
      setLoading(true);
      onClosePopup();
      const options: AxiosRequestConfig = {};
      const formData = new FormData();
      if (selectedImage.name && !deleteImage) {
        formData.append("image", selectedImage, selectedImage.name);
      }

      if (!creatingNew) {
        formData.append("deleteImage", deleteImage.toString());
      }

      formData.append("page", page);
      formData.append("title", title);
      formData.append("description", description);
      await (creatingNew ?
        api.post(`/enterprises/${enterpriseId}/info`, formData, options) :
        api.put(`/enterprises/info/${infoId}`, formData, options));
      setErrorMessage("");
      if (creatingNew) {
        props.history.goBack();
      } else {
        setSelectedImage({} as File);
        await LoadEnterpriseInfo();
        setShowSuccessPopup(true);
      }
    }
    catch (error: any) {
      setErrorMessage(error?.response?.data?.message)
    }
    finally {
      setLoading(false);
      onClosePopup();
    }
  }

  function onOpenPopUp() {
    setShowPopup(true);
  }
  function onClosePopup() {
    setShowPopup(false);
  }
  function onChangeImage(event) {
    setSelectedImage(event.target.files[0]);
    setDeleteImage(false)
  };

  function GetImageUrl(): string {
    return GetFileFromURL(imageUrl, `${process.env.REACT_APP_BASE_URL}/enterprises/info/${infoId}/image`);
  }

  function ShowSuccessPopup() {
    return (
      <InfoModal
        show={showSuccessPopup}
        onHide={() => setShowSuccessPopup(false)}
        loading={false}
        title="Planta editada com sucesso!"
        body="Suas edições foram salvas com sucesso!"
        primaryText="OK"
        primaryOnClick={() => setShowSuccessPopup(false)}
        primaryDisabled={false}
      />
    )
  }

  function OnPageChange(e) {
    ///Remove tudo que não for numero (. ou -, por exemplo)
    console.log(e.target.value.replace(/\D/g, ""));
    setPage(e.target.value.replace(/\D/g, ""));
  }
  return (
    <Style className="default-page">
      <PageTitle title="Detalhes da Planta" />
      {ShowSuccessPopup()}
      <TwoButtonsModal
        show={showPopup}
        onHide={onClosePopup}
        loading={false}
        title={creatingNew ? "Cadastrar Página" : "Editar Página"}
        body={"Você tem certeza que deseja " + (creatingNew ? " cadastrar esta página?" : " editar esta página?")}
        secondaryText="Fechar"
        secondaryOnClick={onClosePopup}
        secondaryDisabled={loading}
        primaryText="Confirmar"
        primaryOnClick={() => OnSubmit()}
        primaryDisabled={loading}
      />
      <div className="default-page">
        <div>
          <button onClick={() => props.history.goBack()} className=" btn-secondary return-button">Voltar</button>
        </div>
        <Spinner spinning={loading} />
        {errorMessage && <p className="alert alert-error">Erro: {errorMessage}</p>}
        <main className="default-main">
          <div className="panel">
            <form className="main-form" onSubmit={(e) => { e.preventDefault(); OnSubmit(); }}>
              <h2>{creatingNew ? "Criação" : "Edição"} de Página de Informação</h2>
              <div>
                <label>Página:</label>
                <input
                  type="text"
                  min="1"
                  max={Math.pow(2, 32) - 1} ///uint 32bits

                  disabled={loading}
                  value={page}
                  onChange={OnPageChange}
                />
              </div>
              <div>
                <label>Titulo:</label>
                <input

                  disabled={loading}
                  defaultValue={title}
                  onChange={e => setTitle(e.target.value)}
                />
              </div>
              <div >
                <label>Descrição:</label>
                <div>
                  <textarea

                    disabled={loading}
                    defaultValue={description}
                    onChange={e => setDescription(e.target.value)}
                    cols={60}
                  />
                </div>
              </div>
              <div>
                <label>Imagem:</label>
                <InputImage
                  id="Image"
                  name="image"
                  label=""
                  alt="Imagem da planta"
                  acceptedMimeTypes="image/png, image/jpeg"
                  imageUrl={GetImageUrl()}
                  OnChange={onChangeImage}
                  OnRemove={() => setDeleteImage(true)}
                  image={selectedImage}
                />
              </div>

              <button
                className="btn btn-success btn-lg mt-4"
                type="button"
                disabled={loading}
                onClick={e => { e.preventDefault(); onOpenPopUp(); }}>
                {creatingNew ? "Cadastrar" : "Editar"}
              </button>
            </form>
          </div>
        </main>
      </div>
    </Style>
  )
}
